class PlanPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'plan.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'plan._m';

    // Can access unpublished plans
    static ACCESS_UNPUBLISHED = 'plan.access.unpublished';

    // Can access legacy plans
    static ACCESS_LEGACY = 'plan.access.legacy';

    // Can access archived plans
    static ACCESS_ARCHIVE = 'plan.access.archive';

    // Can access plans with setup mode = disabled
    static ACCESS_SETUP_DISABLED = 'plan.access.setup.disabled';

    // Can access plans with internal setup mode
    static ACCESS_SETUP_INTERNAL = 'plan.access.setup.internal';

    // Can create new plan
    static CREATE = 'plan.create';

    // Update plan info
    static INFO_UPDATE = 'plan.info.update';

    // Publish plan
    static PUBLISH = 'plan.publish';

    // Can archive plan
    static ARCHIVE = 'plan.archive';

    // Can restore archived plan
    static RESTORE = 'plan.restore';

    // Manage plan attachments
    static ATTACHMENT_MANAGE = 'plan.attachment.manage';
}

export default PlanPermission;
